import { graphql } from "react-relay";

export const RemoveBindingMutation = graphql`
  mutation RemoveBindingMutation(
    $uuid: String!
    $names: [String!]!
    $connections: [ID!]!
  ) {
    removeBinding(uuid: $uuid) {
      binding {
        id @deleteRecord
      }
    }
    removeReportGroups(names: $names) @deleteEdge(connections: $connections)
  }
`;
